import React from 'react'
import TopBar from '../additions/TopBar';
import Header from '../additions/Header';
import Footer from '../additions/Footer';
import FavoriteProducts from './FavoriteProducts';

export default function MyFavorites() {
  return (
    <section className=''>
      <TopBar />
      <Header />
      <div className='bg-gray-50'>
        <FavoriteProducts/>
      </div>
      <Footer />
    </section>
  )
}
